import { HelpBoxMultipleOutlineIcon } from './HelpBoxMultipleOutlineIcon';

/**
 * author: Andrej Sharapov
 * id F2D1319A-DF90-41CD-8791-B9B5685EFAC8
 * name help-box-multiple-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-box-multiple-outline.svg
 * tags
 */
export const QuizOutlineIcon = HelpBoxMultipleOutlineIcon;
export default QuizOutlineIcon